import WsService from "../WsService";
import AgentAnnouncementCategory from "../../domain/agentannouncement/AgentAnnouncementCategory";

const ENDPOINT_BASE = "/agent-announcement/category";

export default class AgentAnnouncementCategoryService{

  static retrieveAll() {

    return WsService.get(ENDPOINT_BASE, {}, 200).then(
      response => {
        let responseArray = [];
        response.forEach(announcement => {
          responseArray.push(new AgentAnnouncementCategory(announcement))
        });
        return responseArray;
      },
      response => {
        return response;
      });
  }

}
